import React, {useEffect, useState, useRef, useCallback, useLayoutEffect} from 'react';
import Modal from "../../Container/Modal";

// style
import HomeStyle from './style';

// images
import Sort from "../../Assets/sort.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import Pen from "../../Assets/pen.svg";

// components
import RightSideBar from '../../Container/RightSidebar/zip';

// -- redux
import {connect} from "react-redux";
import {GetZip, UpdateZipStatus, DeleteZip, ImportData} from "../../Redux/Actions/ZipAction"
import Loader from "../../Container/Loader";

function Zip(props) {
    const [response, setResponse] = useState(false);
    const [Open, SetOpen] = useState(false);
    const [Loaders, SetLoaders] = useState(false);
    const [page, setPage] = useState(1);
    const [Data, SetData] = useState('');
    const [sortType, setSortType] = useState('asc');
    const [sortBy, setSortBy] = useState('1');
    const [tableEntries, setTableEntries]=useState([]);
    const [hasMore, setHasMore] = useState('');
    const [OpenModal, setModal] = useState(false);
    const [Name, setName] = useState(false);
    const [update, setUpdate] = useState(false);
    const [ZipID, setZipID] = useState(false);


    const handleEdit = (e, data) => {
        e.preventDefault();
        SetData(data);
        SetOpen(true)
    };

    useEffect(() => {
        setTimeout(function () {
            setResponse(true)
        }, 1000)
    }, []);

    const deleteZip = (e, type, id) => {
        e.preventDefault();
        setModal(type);
        setZipID(id)
    };

    const observer = useRef();
    const lastItem = useCallback(node => {
        if(props.loading) return;
        if(observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if(entries[0].isIntersecting && hasMore){
                setPage(prevPage => prevPage + 1)
            }
        });
        if(node) observer.current.observe(node)
    }, [props.loading, hasMore]);

    useEffect(() => {
        const data = {
            page: page,
            sort_type: sortType,
            status: props.status,
            sort_by: sortBy,
            search_key: props.search
        };
        props.GetZip(data);
        props.clear('');
        SetOpen(false);
    }, [props.status_data, props.add_data, props.edit_data, props.delete_data, props.status, sortType, sortBy, props.import_data, page]);

    useEffect(() => {
        if(props.search.length > 2){
            SetLoaders(!Loaders);
            const data = {
                page: 1,
                sort_type: '',
                status: '',
                sort_by: '',
                search_key: props.search
            };
            props.GetZip(data);
        } else if(!props.search){
            const data = {
                page: 1,
                sort_type: sortType,
                status: props.status,
                sort_by: sortBy,
                search_key:  ''
            };
            props.GetZip(data);
        }
    }, [props.search]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            props.enabled(props.data.data.enabled);
            props.disabled(props.data.data.disabled);
            setTableEntries(prevData => {
                return [...new Set([...prevData, ...props.data.data.data])]
            });
            setHasMore(props.data.data.data.length > 0)
        }
    }, [props.data, props.add_data, props.edit_data, props.delete_data, Loaders]);

    useEffect(() => {
        props.clear('clear');
    },[]);

    const handleModal = (e, type,name, id) => {
        e.preventDefault();
        setModal(type);
        setName(name);
        setZipID(id);
    };

    useEffect(() => {
        setTableEntries([]);
        setPage(1)
    }, [props.status_data, props.add_data, props.edit_data, props.delete_data, Loaders, props.status, sortType, sortBy, props.import_data]);

    useEffect(() => {
        props.import_data && response && props.UploadResp(props.import_data);
    }, [props.import_data]);

    const CloseModal = (e, type) => {
        e.preventDefault();
        let data;
        if(type === 'enable_yes'){
            data = {
                id: ZipID,
                status: 0
            };
            props.UpdateZipStatus(data);
            setTimeout(function () {
                setUpdate(!update);
            }, 1000)
        } else{
            setModal(!OpenModal)
        }

        if(type === 'disable_yes'){
            data = {
                id: ZipID,
                status: 1
            };

            props.UpdateZipStatus(data);
            setTimeout(function () {
                setUpdate(!update);
            }, 1000)
        } else{
            setModal(!OpenModal)
        }
        if(type === 'delete_yes'){
            props.DeleteZip(ZipID);
            setModal(false)
        } else if(type === 'delete_no'){
            setModal(false)
        }
    };

    const handleSort = (e, type) => {
        e.preventDefault();
        if(type === 'zipcode'){
            setSortBy('1');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else if(type === 'state'){
            setSortBy('2');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else if(type === 'city'){
            setSortBy('3');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        } else{
            setSortBy('2');
            sortType === 'asc' ? setSortType('desc') : setSortType('asc')
        }
    };

    const firstUpdate = useRef(true);
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        if(props.fileInfo) {
            props.ImportData(props.fileInfo);
        }
        
    }, [props.fileInfo]);

    useEffect(() => {
        props.clear('clear');
        setTimeout(function () {
            props.clear('');
        }, 1000)
    }, []);

    const showAMPM = (time) => {
        let AMPM = ''
        let hourStr = ''
        let minStr = ''
        if(time) {
            let hours = parseInt(time.split(":")[0],10)
            let minutes = parseInt(time.split(":")[1],10)
            if(hours > 11) {
                if(hours > 12) hours = hours - 12
                AMPM = 'PM'
            } else {
                AMPM = 'AM'
                if(hours === 0) hours = 12
            }
            if(hours < 10){
                hourStr= '0'+String(hours)
            }else {
                hourStr=String(hours)
            }
            if(minutes < 10){
                minStr= '0'+String(minutes)
            }else {
                minStr = String(minutes)
            }
            return(hourStr + ' : '+ minStr+' '+AMPM)
        } else {
            return time
        }
    };

    return (
        <>
            {props.loading && <Loader/>}
            <div className="ml-4 mr-2">
                <div className="module-table-wrap table-responsive">
                    <div className="table-wrap">
                        <table className="table table-bordered m-0">
                            <thead className='text-grey-6'>
                            <tr>
                                <th scope="col" className="dark-background">
                                    <div
                                        onClick={(e) => handleSort(e, 'zipcode')}
                                        className="d-flex justify-content-between cursor-pointer">
                                            <span className='f-16'>Zipcode</span>
                                            <img src={Sort} alt="sort" className="ml-2"/>
                                    </div>
                                </th>
                                <th scope="col" className="dark-background">
                                    <div
                                        onClick={(e) => handleSort(e, 'city')}
                                        className="d-flex justify-content-between cursor-pointer">
                                            <span className='f-16'>City</span>
                                            <img src={Sort} alt="sort" className="ml-2"/>
                                    </div>
                                </th>
                                <th scope="col" className="dark-background" style={{width: '190px'}}>
                                    <div
                                        onClick={(e) => handleSort(e, 'state')}
                                        className="d-flex justify-content-between cursor-pointer">
                                            <span className='f-16'>State</span>
                                            <img src={Sort} alt="sort" className="ml-2"/>
                                    </div>
                                </th>
                                <th scope="col" className="dark-background">
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Service Start Time</span>
                                    </div>
                                </th>
                                <th scope="col" className="dark-background">
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Service End Time</span>

                                    </div>
                                </th>
                                <th scope="col" className="dark-background">
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Status</span>

                                    </div>
                                </th>
                                <th scope="col" className="dark-background">
                                    <div className="d-flex justify-content-between">
                                        <span className='f-16'>Action</span>

                                    </div>
                                </th>
                            </tr>
                            </thead>
                            <tbody className='light-grey-background text-white'>
                            {tableEntries.length > 0 ? tableEntries.map((item,index)=>{
                                return <tr key={index}>
                                    {tableEntries.length === index + 1 ?
                                        <td ref={lastItem}>
                                        <span className='f-16'>
                                            {item.zip_code}
                                        </span>
                                        </td> : <td>
                                    <span className='f-16'>
                                        {item.zip_code}
                                    </span>
                                    </td>}
                                    <td>
                                    <span className='f-16'>
                                        {item.city}
                                    </span>
                                    </td>
                                    <td>
                                    <span className='f-16'>
                                        {item.state}
                                    </span>
                                    </td>
                                    <td>
                                    <span className='f-16'>
                                        {showAMPM(item.service_start_time)}
                                    </span>
                                    </td>
                                    <td>
                                    <span className='f-16'>
                                        {showAMPM(item.service_end_time)}
                                    </span>
                                    </td>
                                    <td className='text-center'>
                                    <label className="switch mb-0">
                                        <input
                                            type="checkbox"
                                            checked={item.zip_code_status}
                                            readOnly
                                        />
                                        <span className="slider round" onClick={(e) => handleModal(e, item.zip_code_status === 1 ? 'enable' : 'disable',"zipcode", item.id)} />
                                    </label> 
                                    </td>
                                    <td>
                                        <div className="d-flex">
                                            <img src={Pen} alt="pen" className="ml-2 mr-2 cursor-pointer" onClick={(e)=> handleEdit(e, item)}/>
                                            <img onClick={(e) => deleteZip(e, 'delete', item.id)} src={DeleteIcon} alt="Delete" className="ml-2 cursor-pointer"/>
                                        </div>
                                    </td>
                                </tr>
                            })
                            : props.table_loading === false && <tr><td colSpan='9' className='text-center border-0'>
                                    <p className='m-0 text-white'>Nothing found</p>
                                </td></tr>
                            }
                            </tbody>
                        </table>
                        {props.table_loading &&
                            <div className='text-center w-100'>
                                <p className='text-white mt-5 font-weight-bold'>Loading...</p>
                            </div>
                        }
                        <HomeStyle/>
                    </div>
                </div>
                <RightSideBar
                    Type='Edit'
                    item_data={Data}
                    sidebar={Open}
                    close={() =>  SetOpen(false)}
                    response={(e) => (e)}
                />
                { OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/> }

            </div>
        </>
    );
}

const mapStateToProps = ({ZipReducer}) => {
    const {loading, table_loading, data, add_data, edit_data, status_data, delete_data, import_data} = ZipReducer;
    return {loading, table_loading, data, add_data, edit_data, status_data, delete_data, import_data}
};

const mapDispatchToProps = {
    GetZip,
    UpdateZipStatus,
    DeleteZip,
    ImportData
};

export default connect(mapStateToProps, mapDispatchToProps)(Zip);